import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faLinkedinIn, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';

const socialData = [
  { iconId: faFacebookSquare, slug: '!#' },
  { iconId: faLinkedinIn, slug: '!#' },
  { iconId: faInstagram, slug: '!#' },
  { iconId: faYoutube, slug: '!#' }
];

const SocialLinks = () => (
  <Fragment>
    <p className="d-none d-md-block small text-left font-weight-bold mb-0">Follow us on</p>
    <ul className="Footer-Promoted__Social">
      {
        socialData.map((data, index) => (
          <li key={index}>
            <a href={data.slug}>
              <FontAwesomeIcon 
                size="2x"
                color="#ffffff"
                icon={data.iconId} 
              />
            </a>
          </li>
        ))
      }
    </ul>
  </Fragment>
);

export default SocialLinks;